import React from 'react';
import styles from './Row.module.css';

const colMap = {
  auto: styles.colAuto,
  1: styles.col1,
  2: styles.col2,
  3: styles.col3,
  4: styles.col4,
  5: styles.col5,
  6: styles.col6,
  7: styles.col7,
  8: styles.col8,
  9: styles.col9,
  10: styles.col10,
  11: styles.col11,
  12: styles.col12,
};

export default function Row({ children, className = '', gutter = 'md', ...rest }) {
  return (
    <div className={`${styles.row} ${styles[`gutter-${gutter}`]} ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function Col({ children, span, className = '', ...rest }) {
  return (
    <div className={`${styles.col} ${span ? colMap[span] || styles.col : ''} ${className}`} {...rest}>
      {children}
    </div>
  );
}
